<script>
import HeaderMenu from '@/components/HeaderMenu';
import responsiveMixin from '@/mixins/responsiveMixin';
import CookieMonster from '@/components/CookieMonster';

export default {
  components: {
    CookieMonster,
    HeaderMenu,
  },
  mixins: [responsiveMixin],
};
</script>

<template>
<v-app>
  <v-app-bar
    app
    :flat="!isMobile"
    :absolute="!isMobile"
    :color="isMobile ? 'white' : 'transparent'"
  >
    <a
      href="https://www.respondent.io"
      aria-label="Go to homepage"
      :class="responsiveClasses({ mobile: 'small', desktop: 'ml-5' })"
    >
      <v-img
        v-if="isMobile"
        src="https://respondentinc-assets.s3.amazonaws.com/images/logo_small_2023.svg"
        alt="respondent logo"
        width="32px"
        height="32px"
        contain
      />
      <v-img
        v-else
        src="https://respondentinc-assets.s3.amazonaws.com/images/logo_2023.svg"
        alt="respondent logo"
        width="200px"
        height="32px"
        contain
      />
    </a>
    <v-spacer />
    <header-menu />
  </v-app-bar>
  <v-main class="overflow-hidden">
    <slot />
  </v-main>

  <cookie-monster />
</v-app>
</template>

<style scoped>
a.small {
  height: 34px;
}

.fs-14 {
  font-size: 14px;
}
</style>
